<template>
  <div class="modal-backdrop" @click.self="close">
    <div class="modal-content">
      <h3>Alterar Horário</h3>
      <form @submit.prevent="salvarHorario">
        <div class="row">

          <div class="col">
            <label for="horario">Horario</label>
            <input type="text" id="horario" v-model="form.horario" required placeholder="Digite o Horário" />
          </div>
        </div>



        <div class="buttons">
          <button type="submit">Salvar</button>
          <button type="button" @click="close">Cancelar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch } from "vue";
import { defineEmits, defineProps } from "vue";
import { useStorage } from "vue3-storage";

const props = defineProps({
  horario: {
    type: Object,
    required: true,
  },

});

const emit = defineEmits("close");

const storage = useStorage();
const id = storage.getStorageSync("id");
const token = storage.getStorageSync("token");

const form = reactive({
  horario: '',
});

// Watch para reagir às mudanças nas props
watch(() => props.horario, (newHorario) => {
  if (newHorario && newHorario.hora) {
    form.horario = newHorario.hora;
  } else {
    form.horario = '';
  }
}, { immediate: true });

async function salvarHorario() {
  emit("salvar", form);
}

function close() {
  emit("close");
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  width: 70vw;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.modal-content h3 {
  margin-top: 0;
  margin-bottom: 1rem;
  font-weight: 600;
}

.modal-content label {
  display: block;
  margin-top: 0.5rem;
  margin-bottom: 0.25rem;
  font-weight: 500;
}

.modal-content input,
.modal-content select,
.modal-content textarea {
  width: 100%;
  padding: 0.4rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.buttons {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.buttons button {
  padding: 0.4rem 0.8rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.buttons button[type="submit"] {
  background-color: #56008f;
  color: white;
}

.buttons button[type="button"] {
  background-color: transparent;
  border: 2px solid #56008f;
  color: #56008f;
}
</style>
